import React from 'react';
import { connect } from 'react-redux';

class BusyScreen extends React.Component{
    render() {
        if (this.props.busy_restart) {
            return (
                <div className="loader_base">
                    <div className="loader"/>
                </div>
            )
        } else {
            if (this.props.loading) {
                return (
                    <div className="spinner_base">
                        <div className="spinner"/>
                    </div>
                )
            } else {
                return null;
            }
        }

    }
}

function mapStateToProps(state) {
    return {
        busy_restart: state.systemR.config_data.system_restarting,
        loading: state.systemR.loading
    };
}

export default BusyScreen = connect(
    mapStateToProps, null)(
    BusyScreen
);